import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=13757cc8&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=13757cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13757cc8",
  null
  
)

export default component.exports